module.exports = __webpack_public_path__ + "media/images/vp/samples/25-8db2000b97574d1a1495d306e11b4995.jpg";